import { Pipe, PipeTransform } from "@angular/core";
import { getNumberOfDigits } from "../helper";

@Pipe({
    standalone: true,
    name: 'digitsNumber'
})
export class CheckNumberOfDigitsPipe implements PipeTransform {
    transform(value: number, digitCountLimit: number): boolean {
       return getNumberOfDigits(value) > digitCountLimit;
    }
}